
import { defineComponent } from "vue";
import IconButton from "@/components/IconButton.vue";

export default defineComponent({
  name: "ImageViewer",

  components: {
    IconButton
  },

  props: {
    modelValue: {
      type: Boolean,
      required: true
    },

    image: {
      type: String,
      required: true
    }
  },

  methods: {
    close() {
      this.$emit("update:modelValue", false);
    }
  }
});
